module.exports = __webpack_public_path__ + "static/media/S42.2aa66303.png";